/* AppraisalComponents/constants.js — Phase C · C4a shell extraction.
 *
 * Pure data constants used across the Components tab surface. Extracted
 * from AppraisalComponentsTab.js (2026-02c) as the first step of the
 * mega-file split. Zero React state · zero side effects · safe to import
 * from any per-work-type subform (C4b/c/d).
 *
 * Structure follows the "flatter" split preference (user 2026-02c):
 * parent still owns state · per-work-type files import these constants
 * without state-lifting complexity.
 */

// Iter148 — Map AppraisalComponentsTab section keys to the
// IronRateDetailModal preset key. The modal supports 7 presets
// (sheet/ridge/barge/valley/flashing/fastening/tile); every other
// section falls back to `sheet` (generic Buy/Material/Labour/
// Contractor + Hours-per-m UI).
export const RATE_MODAL_PRESET_BY_SECTION = {
  Sheet: 'sheet',
  Ridge: 'ridge',
  Barge: 'barge',
  Valley: 'valley',
  Flashing: 'flashing',
  Tile: 'tile',
  Aquaseal: 'flashing',
};

export const WORK_TYPES = [
  { key: 'Cleaning',  colour: '#0EA5E9', prefix: 'Cl' },
  { key: 'Travel',    colour: '#6366F1', prefix: 'Tr' },
  { key: 'Urgent',    colour: '#DC2626', prefix: 'Ur' },
  { key: 'Safety',    colour: '#EAB308', prefix: 'Sa' },
  { key: 'Sheet',     colour: '#D35400', prefix: 'Sh' },
  { key: 'Tile',      colour: '#A16207', prefix: 'T'  },
  { key: 'Ridge',     colour: '#9333EA', prefix: 'R'  },
  { key: 'Valley',    colour: '#2563EB', prefix: 'V'  },
  { key: 'Barge',     colour: '#7C3AED', prefix: 'B'  },
  { key: 'Spouting',  colour: '#0891B2', prefix: 'Sp' },
  { key: 'Fastening', colour: '#DB2777', prefix: 'Fa' },
  { key: 'Flashing',  colour: '#059669', prefix: 'Fl' },
  { key: 'Underlay',  colour: '#475569', prefix: 'U'  },
  { key: 'Aquaseal',  colour: '#0D9488', prefix: 'AQ', label: 'Dektite' },
  { key: 'ReCoat',    colour: '#DC2626', prefix: 'Rc' },
  // Face + Length surface diagram-pin types that previously had no
  // home on the Components tab and were silently dropped after a
  // Push-to-Components. They carry their own ref prefixes (FA / L)
  // so the diagram and the line list stay in lockstep.
  { key: 'Face',      colour: '#92400E', prefix: 'FA' },
  { key: 'Length',    colour: '#92400E', prefix: 'L'  },
  { key: 'Misc',      colour: '#64748B', prefix: 'M'  },
  { key: 'Other',     colour: '#475569', prefix: 'O'  },
];

export const PREFIX_BY_TYPE = WORK_TYPES.reduce(
  (m, w) => { m[w.key] = w.prefix; return m; },
  {},
);

// Component types that use "Units" instead of "Length" (charged per item, not per metre).
export const UNIT_BASED_TYPES = new Set([
  'Cleaning', 'Travel', 'Urgent', 'Safety', 'Tile', 'Fastening',
  'Underlay', 'Aquaseal', 'ReCoat', 'Misc', 'Other',
]);

// Iter149 — Spouting Bracket Summary tag markers. Auto-generated rows
// carry an [AUTO:*] prefix in the `notes` field so re-pushes replace
// cleanly. Mitre corner rows carry [MITRE] to feed the bracket-count
// math without a schema migration.
export const MITRE_TAG = '[MITRE]';
export const AUTO_BRACKET_TAG = '[AUTO:bracket]';
